"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _reactRouterDom = require("react-router-dom");

var _Popover = _interopRequireDefault(require("../Popover"));

var _LoadingIndicator = _interopRequireDefault(require("../effect/LoadingIndicator"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _device = require("../../toolkit/device");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_TYPE = "default";
var DEFAULT_BORDER_RADIUS = 4;
var propDoc = {
  onClick: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "Optional callback for button click"
  },
  type: {
    required: false,
    defaultValue: "".concat(DEFAULT_TYPE),
    type: "\"default\" | \"cassette\" | \"select\"",
    description: "Style of the buttom"
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the button is disabled. " + "Set this to true while making API call."
  },
  isRouterLink: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "If the button is being used as a link, use this value to " + "indicate if it is an internally handled link. Internal links " + "are handled by JS and do not refresh the page"
  },
  href: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "If button is a link, set this to the `href` value"
  },
  isLoading: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Set to true while the button's action is happening"
  },
  text: {
    required: false,
    defaultValue: "null",
    type: "string",
    description: "Text of the button. Text can also be " + "rendered as a child of the button\n    `<SecondaryButton>Click me</SecondaryButton>`\n     "
  },
  padding: {
    required: false,
    defaultValue: "7px <based on screen size>px",
    type: "string",
    description: "Internal padding of the button"
  },
  borderRadius: {
    required: false,
    defaultValue: "".concat(DEFAULT_BORDER_RADIUS),
    type: "?number",
    description: "Border radius of the button in pixels"
  },
  popoverContent: {
    required: false,
    defaultValue: "null",
    type: "(string | null) | ((() => ReactNode))",
    description: "Set if the button displays a popover when hovered. Value is the " + "popover's content: either string or a custom render function "
  },
  popoverPosition: {
    required: false,
    defaultValue: "top center",
    type: "string | null | undefined",
    description: "Position of the button's popover -- if it has one"
  },
  color: {
    required: false,
    defaultValue: "WishBlue",
    type: "string",
    description: "Color of the button, defaults to the theme's primary color"
  }
};
var demoRender = "\n<SecondaryButton onClick={() => null}>\n  Click me\n</SecondaryButton>\n";
var demoProps = {
  href: "http://www.google.com"
};

var InnerButton = function InnerButton(props) {
  var _useTheming = (0, _providers.useTheming)(),
      primary = _useTheming.theme.primary;

  var className = props.className,
      style = props.style,
      children = props.children,
      onClick = props.onClick,
      href = props.href,
      disabledProp = props.disabled,
      text = props.text,
      _props$type = props.type,
      type = _props$type === void 0 ? DEFAULT_TYPE : _props$type,
      isLoading = props.isLoading,
      isRouterLink = props.isRouterLink,
      isSelected = props.isSelected,
      _props$color = props.color,
      color = _props$color === void 0 ? primary : _props$color,
      _props$openInNewTab = props.openInNewTab,
      openInNewTab = _props$openInNewTab === void 0 ? false : _props$openInNewTab;
  var disabled = isLoading || disabledProp == true;
  var styles = useStylesheet(props, disabled);
  var navigator = (0, _providers.useLegoNavigator)();
  var rootStyle = null;

  switch (type) {
    case "default":
      rootStyle = styles["default"];

    case "cassette":
      rootStyle = isSelected ? styles.colourMode : styles["default"];

    case "select":
      rootStyle = isSelected ? styles.select : styles["default"];
  }

  var canClick = !isLoading && !disabled && onClick != null;
  var onClickValue = canClick ? onClick : null;
  var rootCSS = (0, _styling.css)(styles.basic, rootStyle, [className], style, !disabled && type != "cassette" && "ripple-white");

  if (href != null && !disabled) {
    var linkProps = {
      className: rootCSS || undefined
    };

    if (isRouterLink) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({}, linkProps, {
        title: text,
        to: href
      }), text || children);
    }

    var onClickHandler = function onClickHandler(e) {
      if (href) {
        navigator.navigate(href, {
          openInNewTab: openInNewTab
        });
        e.preventDefault();
      }

      if (onClickValue) {
        onClickValue(e);
      }
    };

    linkProps = _objectSpread(_objectSpread({}, linkProps), {}, {
      onClick: onClickHandler
    });
    return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({}, linkProps, {
      title: text,
      href: href
    }), text || children);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootCSS,
    onClick: onClickValue || undefined,
    title: text
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.content)
  }, isLoading && /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
    className: (0, _styling.css)(styles.loading),
    type: "spinner",
    size: 16,
    color: color
  }), /*#__PURE__*/_react["default"].createElement("span", null, text || children)));
};

var SecondaryButton = function SecondaryButton(props) {
  var popoverPosition = props.popoverPosition,
      popoverContent = props.popoverContent,
      className = props.className,
      isLoading = props.isLoading,
      disabledProp = props.disabled;
  var disabled = isLoading || disabledProp == true;
  var styles = useStylesheet(props, disabled);
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    position: popoverPosition || "top center",
    popoverMaxWidth: 250,
    popoverContent: popoverContent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.container, className)
  }, /*#__PURE__*/_react["default"].createElement(InnerButton, props)));
};

SecondaryButton.propDoc = propDoc;
SecondaryButton.demoProps = demoProps;
SecondaryButton.demoRender = demoRender;

var _default = (0, _mobxReact.observer)(SecondaryButton);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props, disabled) {
  var _useDeviceStore = (0, _device.useDeviceStore)(),
      isSmallScreen = _useDeviceStore.isSmallScreen;

  var _useTheming2 = (0, _providers.useTheming)(),
      _useTheming2$theme = _useTheming2.theme,
      primaryLight = _useTheming2$theme.primaryLight,
      primary = _useTheming2$theme.primary,
      surfaceLightest = _useTheming2$theme.surfaceLightest,
      textWhite = _useTheming2$theme.textWhite,
      fonts = _useTheming2.fonts;

  var padding = props.padding,
      _props$color2 = props.color,
      color = _props$color2 === void 0 ? primary : _props$color2,
      border = props.border,
      _props$borderRadius = props.borderRadius,
      borderRadius = _props$borderRadius === void 0 ? DEFAULT_BORDER_RADIUS : _props$borderRadius,
      type = props.type,
      popoverContent = props.popoverContent;
  var loadingKeyframes = {
    from: {
      transform: "scale(0, 0)",
      opacity: 0.5
    },
    to: {
      transform: "scale(1, 1)",
      opacity: 1
    }
  };
  var defaultPadding = "7px ".concat(isSmallScreen ? 25 : 60, "px");
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      basic: {
        display: "flex",
        userSelect: "none",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "default" : "pointer",
        flexDirection: "column",
        textRendering: "optimizeSpeed",
        borderRadius: borderRadius,
        padding: padding || defaultPadding,
        opacity: disabled ? 0.4 : 1,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        ":hover": {
          textDecoration: "none"
        },
        ":visited": {
          textDecoration: "none"
        },
        ":active": {
          textDecoration: "none"
        }
      },
      "default": {
        fontSize: 15,
        transition: "all 0.2s linear",
        transitionProperty: "opacity, background-color",
        flex: popoverContent ? 1 : undefined,
        fontFamily: fonts.medium,
        border: border || "solid 1px ".concat(color),
        color: color,
        backgroundColor: surfaceLightest,
        ":hover": {
          color: !disabled && type != "cassette" ? textWhite : undefined,
          backgroundColor: !disabled && type != "cassette" ? color : undefined,
          textDecoration: "none"
        },
        ":link": {
          textDecoration: "none"
        },
        ":visited": {
          textDecoration: "none"
        },
        ":active": {
          textDecoration: "none"
        }
      },
      colourMode: {
        fontSize: 15,
        fontFamily: fonts.semibold,
        transition: "all 0.3s linear",
        transitionProperty: "opacity, background-color, box-shadow",
        color: textWhite,
        backgroundColor: color,
        ":active": {
          opacity: disabled ? 0.8 : undefined
        },
        ":hover": {
          opacity: disabled ? 0.8 : undefined
        }
      },
      select: {
        fontSize: isSmallScreen ? 12 : 14,
        fontFamily: fonts.medium,
        transition: "all 0.3s linear",
        transitionProperty: "opacity, background-color, box-shadow",
        border: "solid 1px ".concat(primaryLight),
        color: primary,
        backgroundColor: primaryLight
      },
      content: {
        display: "flex",
        fontSize: isSmallScreen ? 16 : undefined,
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between"
      },
      loading: {
        animationName: [loadingKeyframes],
        animationDuration: "400ms",
        marginRight: 10
      },
      container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        borderRadius: borderRadius
      }
    });
  }, [border, borderRadius, color, defaultPadding, disabled, isSmallScreen, loadingKeyframes, padding, popoverContent, type, primaryLight, primary, surfaceLightest, textWhite, fonts.medium, fonts.semibold]);
};